import { c as _c } from "react/compiler-runtime";
import { type RoundupDriverGroupEnum, TrafficOriginType } from '@repo/contracts/marketplace/offers/enums';
import type { Offer } from '@repo/contracts/marketplace/offers/types';
import { isAmexOffer } from '@repo/contracts/marketplace/offers/utils';
import { FlexGrid } from '@repo/pandacss/jsx';
import type { AnalyticsMarketplacePayload } from '@repo/platform-analytics/types';
import type { AllDrivers } from '../../model/types';
import { getDefaultApprovalOddsTextContentDriver } from '../ApprovalOdds/ApprovalOddsTextContent';
import { ApprovalOddsDriver } from './ApprovalOddsDriver';
import { Driver } from './Driver';
import { getStaticDrivers } from './getStaticDrivers';
import { driverFlexColumns, driversGridStyles } from './layout/styles';
import { getDriverLayoutVariantMap, processDriverLayout } from './layout/utils';
export const DriversContainer = t0 => {
  const $ = _c(9);
  const {
    creditCardOffer,
    marketplacePayload,
    driverGroup,
    segmentActionSection,
    trafficOriginType,
    isLtoHighlightingEnabled: t1
  } = t0;
  const isLtoHighlightingEnabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== creditCardOffer || $[1] !== driverGroup || $[2] !== isLtoHighlightingEnabled || $[3] !== marketplacePayload || $[4] !== segmentActionSection || $[5] !== trafficOriginType) {
    const staticDrivers = getStaticDrivers(creditCardOffer, isLtoHighlightingEnabled);
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <></>;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    const allDrivers = {
      ...staticDrivers,
      recommendedCreditScore: {
        id: "recommendedCreditScore",
        label: "",
        value: t3
      }
    };
    if (trafficOriginType === TrafficOriginType.Paid) {
      allDrivers.recommendedCreditScore = getDefaultApprovalOddsTextContentDriver({
        userCreditScore: undefined,
        odds: creditCardOffer.details.creditScore,
        isAmexOffer: isAmexOffer(creditCardOffer)
      });
    }
    const processedLayout = processDriverLayout({
      allDrivers,
      driverGroup
    });
    const layoutVariantMap = getDriverLayoutVariantMap({
      allDrivers,
      driverGroup,
      processedLayout
    });
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        base: "[20px]",
        _pcMd: "6"
      };
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t2 = <FlexGrid container={true} columnSpacing={t4} css={driversGridStyles}>{processedLayout.driverLayout.drivers.map(driverKey => {
        if (driverKey === "recommendedCreditScore" && trafficOriginType !== TrafficOriginType.Paid) {
          return <ApprovalOddsDriver key="driver-recommendedCreditScore" approvalLikelihood={creditCardOffer.details.approvalLikelihood} creditScore={creditCardOffer.details.creditScore} productId={creditCardOffer.product.id} productName={creditCardOffer.product.name} isInstitutionAmex={isAmexOffer(creditCardOffer)} marketplacePayload={marketplacePayload} driverGroup={driverGroup} css={driverFlexColumns.raw(layoutVariantMap.recommendedCreditScore)} segmentActionSection={segmentActionSection} isLtoHighlightingEnabled={isLtoHighlightingEnabled} />;
        }
        const driver = allDrivers[driverKey];
        return <Driver key={`driver-${driver.id}`} css={driverFlexColumns.raw(layoutVariantMap[driverKey])} driver={driver} driverGroup={driverGroup} segmentActionSection={segmentActionSection} isLtoHighlightingEnabled={isLtoHighlightingEnabled} />;
      })}</FlexGrid>;
    $[0] = creditCardOffer;
    $[1] = driverGroup;
    $[2] = isLtoHighlightingEnabled;
    $[3] = marketplacePayload;
    $[4] = segmentActionSection;
    $[5] = trafficOriginType;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};